import { pick, keys } from 'lodash';
/**
   * @ngdoc directive
   * @name adjust.accountSettings.directive:diff
   * @scope
   * @restrict E
   *
   * @description
   * Audit event difference
   *
   * @param {object} event audit event object
   *
   */
function diff() {
  'ngInject';
  return {
    restrict: 'E',
    scope: {},
    template: require('./diff.html'),
    controller: 'DiffController',
    controllerAs: 'vm',
    bindToController: {
      event: '=ngModel'
    }
  };
}

/**
   * @ngdoc controller
   * @name adjust.accountSettings.controller:DiffController
   *
   * @description
   * All the functionality of the {@link adjust.apps.directive:diff diff} directive
   *
   */
function DiffController() {
  'ngInject';
  var vm = this;

  _prepare();

  /**
   * @ngdoc method
   * @name _prepare
   * @methodOf adjust.accountSettings.controller:DiffController
   *
   * @description
   * Prepare before and after json
   *
   * @private
   */
  function _prepare() {

    var restoreUrl = vm.event.attributes.parameters.restore_url;

    vm.before = _getBefore();
    vm.after = _getAfter();

    if (restoreUrl) {

      vm.before = angular.copy(vm.after);
      vm.after  = {restore_url: restoreUrl};
    }

  }

  /**
   * @ngdoc method
   * @name _getBefore
   * @methodOf adjust.accountSettings.controller:DiffController
   *
   * @description
   * Get before json
   *
   * @returns {Object} before json
   * @private
   */
  function _getBefore() {

    return vm.event.attributes.parameters.original_state;

  }

  /**
   * @ngdoc method
   * @name _getAfter
   * @methodOf adjust.accountSettings.controller:DiffController
   *
   * @description
   * Get after json
   *
   * @returns {Object} after json
   * @private
   */
  function _getAfter() {

    var changedParameters = keys(vm.event.attributes.parameters.original_state);
    var parametersToShow = changedParameters.length ? changedParameters : [
      'account_state',
      'ad_accounts',
      'advanced_permissions',
      'app_settings',
      'app_token',
      'app_tokens',
      'partner_id',
      'attribution_price',
      'base_price',
      'callback_url',
      'cost_enabled',
      'currency_iso_code',
      'currency',
      'cut_off_period',
      'email',
      'enabled',
      'events_mapping',
      'expiry_period',
      'full_name',
      'included_attributions',
      'index',
      'is_child_directed',
      'label',
      'login',
      'name',
      'names',
      'partners',
      'reactivation_date',
      'refresh_key',
      'retention_period',
      'revenue_enabled',
      'revenue_with_facebook',
      'secret',
      'settings',
      'store_app_ids',
      'store',
      'suspended_till',
      'tencent_account_id',
      'tencent_account_uin',
      'termination_on',
      'token',
      'unique',
      'username',
      'network_name',
    ];

    return pick(vm.event.attributes.parameters, parametersToShow);

  }
}

export { DiffController, diff };
